import styled from 'styled-components';
import { media } from '@peloton/styles';
import { spaces } from '@engage/styles';
import { CONTENT_MAX_WIDTHS } from '@members/layout';

export const WidthContainer = styled.div`
  padding: 0 10px;
  & > * {
    max-width: ${CONTENT_MAX_WIDTHS.mobile}px;
  }

  ${media.tabletLarge`
    padding: 0 30px;
    & > * {
      max-width: ${CONTENT_MAX_WIDTHS.tabletLarge}px;
    }
  `}

  ${media.desktop`
    padding: 0 ${spaces.huge}px;
    & > * {
      max-width: ${CONTENT_MAX_WIDTHS.desktop}px;
    }
  `}
`;
